import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=7e32a4f8"
import script from "./AdminList.vue?vue&type=script&lang=ts"
export * from "./AdminList.vue?vue&type=script&lang=ts"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=7e32a4f8&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports